import React, { useState, useRef, useEffect } from 'react';

const Tooltip = ({ children }) => {
  const [tooltip, setTooltip] = useState({ 
    visible: false, 
    x: 0, 
    y: 0, 
    content: '', 
    position: 'bottom', 
    offset: { x: 0, y: 0 } 
  });
  const timeoutRef = useRef(null);

  useEffect(() => {
    const showTooltip = (event) => {
      let target = event.target;
      while (target && !target.getAttribute('data-tooltip')) {
        target = target.parentElement;
      }

      if (target && target.getAttribute('data-tooltip')) {
        const tooltipContent = target.getAttribute('data-tooltip');
        const position = target.getAttribute('data-tooltip-position') || 'bottom';
        const rect = target.getBoundingClientRect();
        const offset = target.getAttribute('data-tooltip-offset') 
          ? JSON.parse(target.getAttribute('data-tooltip-offset')) 
          : { x: 0, y: 0 };

        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        timeoutRef.current = setTimeout(() => {
          setTooltip({
            visible: true,
            x: rect.left + rect.width / 2 + offset.x,
            y: position === 'top' ? rect.top + offset.y : rect.bottom + offset.y,
            content: tooltipContent,
            position,
            offset
          });
        }, 350);
      }
    };

    const hideTooltip = (event) => {
      let target = event.target;
      while (target && !target.getAttribute('data-tooltip')) {
        target = target.parentElement;
      }

      if (!target || !target.contains(event.relatedTarget)) {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        setTooltip(prev => ({ ...prev, visible: false }));
      }
    };

    document.addEventListener('mouseover', showTooltip);
    document.addEventListener('mouseout', hideTooltip);

    return () => {
      document.removeEventListener('mouseover', showTooltip);
      document.removeEventListener('mouseout', hideTooltip);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <>
      {children}
      {tooltip.visible && (
        <div
          className="fixed z-50 flex flex-row text-center leading-5 w-fit pt-1 pb-2 px-3 barlow-medium text-base text-amber-50 bg-neutral-800 opacity-90 rounded pointer-events-none"
          style={{
            left: `${tooltip.x}px`,
            top: tooltip.position === 'bottom' ? `${tooltip.y}px` : 'auto',
            bottom: tooltip.position === 'top' ? `calc(100% - ${tooltip.y}px)` : 'auto',
            transform: `translate(-50%, ${tooltip.position === 'bottom' ? '0' : '-100%'})`
          }}
        >
          {tooltip.content}
          <span
            className={`absolute -z-10 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-neutral-800 rotate-45 ${
              tooltip.position === 'bottom' ? 'top-[-4px]' : 'bottom-[-4px]'
            }`}
          />
        </div>
      )}
    </>
  );
};

export default Tooltip;